import React from 'react';
import DashboardSidebar from 'shared/components/DashboardSidebar';
import styles from './DashboardContainer.module.scss';
import { DashboardContainerColorProps } from 'enums/DashboardContainerEnums';
import { Row, Col } from 'antd';
import clsx from 'clsx';

interface DashboardContainerProps {
  children: React.ReactNode;
  noPadding?: boolean;
  bgColor?:
    | DashboardContainerColorProps.GREY
    | DashboardContainerColorProps.WHITE
    | DashboardContainerColorProps.GREY_LIGHT;
  id?: string;
  fullWidthContainer?: boolean;
}

const DashboardContainer: React.FC<DashboardContainerProps> = ({
  children,
  bgColor,
  noPadding,
  id,
  fullWidthContainer,
}: DashboardContainerProps) => {
  const contentContainer = clsx({
    [styles.contentContainer]: true,
    [styles.contentContainerNoPadding]: noPadding,
    [styles.fullWidthContainer]: fullWidthContainer,
    [styles.whiteBg]: bgColor === DashboardContainerColorProps.WHITE,
    [styles.greyBg]: bgColor === DashboardContainerColorProps.GREY,
  });
  return (
    <Row>
      <Col span={1} className={styles.sidebarContainer}>
        <DashboardSidebar />
      </Col>
      <Col span={23} className={contentContainer} id={id}>
        {children}
      </Col>
    </Row>
  );
};

export default DashboardContainer;
